import { defineStore } from 'pinia'
import authServices from '@/api/services/authServices'
import { jwtDecrypt, tokenAlive } from '@/helpers/jwtHelper'
import { useCookies } from '@vueuse/integrations/useCookies'
import { computed, ref } from 'vue'

const $cookies = useCookies(['token', 'refresh_token'])

export const useAuthStore = defineStore('AuthStore', () => {
  const authData = ref({
    token: '',
    refresh_token: '',
    tokenExp: '',
    roles: [],
    username: ''
  })
  const loginStatus = ref('')

  const isAuth = computed(() => !!authData.value.token)

  const isTokenActive = computed(() => {
    if (!authData.value.tokenExp) {
      return false
    }
    return tokenAlive(authData.value.tokenExp)
  })

  const login = async ({ email, password, keepMeLoggedIn }) => {
    const { data } = await authServices.login({ email, password })

    const tokenData = {
      token: data.token,
      refresh_token: data.refresh_token
    }
    saveTokenData({ tokenData, keepMeLoggedIn })
  }

  const saveTokenData = ({ tokenData, keepMeLoggedIn }) => {
    const { token, refresh_token } = tokenData

    if (keepMeLoggedIn || localStorage.getItem('refresh_token')) {
      saveTokensToLocalStorage('refresh_token', refresh_token)
    } else {
      saveTokensToCookies('refresh_token', refresh_token)
    }
    const jwtDecodedValue = jwtDecrypt(token)
    authData.value = {
      token,
      refresh_token,
      tokenExp: jwtDecodedValue.exp,
      roles: jwtDecodedValue.roles,
      username: jwtDecodedValue.username
    }
  }

  const refreshToken = async (refresh_token) => {
    const { data } = await authServices.refreshToken(refresh_token)

    const tokenData = {
      token: data.token,
      refresh_token: data.refresh_token
    }
    saveTokenData({ tokenData })

    return data
  }

  const saveTokensToLocalStorage = (name, token) => {
    localStorage.setItem(name, token)
  }

  const saveTokensToCookies = (name, token) => {
    $cookies.set(name, token)
  }

  const setLoginStatus = (payload) => {
    loginStatus.value = payload
  }

  return {
    authData,
    loginStatus,

    login,
    saveTokenData,
    refreshToken,
    saveTokensToLocalStorage,
    saveTokensToCookies,
    setLoginStatus,
    isTokenActive,

    isAuth
  }
})
